/**
 * Auth Routes
 */

import type { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { CollectPhonePage } from "./pages/collect-phone";
import { PhoneLoginPage } from "./pages/phone-login";
import { SelectUserTypePage } from "./pages/select-user-type";
import { VerifyOtpPage } from "./pages/verify-otp";

export const authRoutes: RouteObject[] = [
	{
		path: "/login",
		element: <PhoneLoginPage />,
	},
	{
		path: "/verify-otp",
		element: <VerifyOtpPage />,
	},
	{
		path: "/collect-phone",
		element: (
			<ProtectedRoute>
				<CollectPhonePage />
			</ProtectedRoute>
		),
	},
	{
		path: "/onboarding",
		element: (
			<ProtectedRoute>
				<SelectUserTypePage />
			</ProtectedRoute>
		),
	},
];
